<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M17.25 10C17.25 6.27208 14.228 3.25 10.5 3.25C6.77208 3.25 3.75 6.27208 3.75 10C3.75 13.728 6.77208 16.75 10.5 16.75C14.228 16.75 17.25 13.728 17.25 10Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.5 13V7M10.5 7L8.25 9.25M10.5 7L12.75 9.25" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'UpgradeIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>